// Fee-record method CODES map to the LABELS stored in the club's acceptedPaymentMethods
// (the "Payment Methods" checkboxes in Settings → Fees & Billing).
export const METHOD_CODE_TO_LABEL = {
  cash:    'Cash',
  bank:    'Bank Transfer',
  khalti:  'Khalti',
  esewa:   'eSewa',
  fonepay: 'Fonepay',
};

// The checkbox options (order shown in Settings). "Other" is intentionally NOT here — it is
// always available as an admin fallback when recording a payment, never a student option.
export const ACCEPTED_METHOD_OPTIONS = ['Cash', 'Bank Transfer', 'Khalti', 'eSewa', 'Fonepay'];

// Is a method code enabled given the club's accepted-methods list?
//  - 'other' is always allowed (admin fallback).
//  - an empty / absent list means "not configured" → treat everything as enabled.
export function isMethodEnabled(code, accepted) {
  if (code === 'other') return true;
  if (!Array.isArray(accepted) || accepted.length === 0) return true;
  const label = METHOD_CODE_TO_LABEL[code];
  return label ? accepted.includes(label) : true;
}
